import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { motion } from "framer-motion";

const Banner = () => {
  const [dotActive, setDocActive] = useState(0);
  
  const slides = [
    {
      img: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=1470&auto=format&fit=crop",
      title: "Kadees Luxury Living",
      subtitle: "Exclusive Modern Furniture 2026",
      link: "/shop"
    },
    {
      img: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?q=80&w=1470&auto=format&fit=crop",
      title: "Elegant Workspace",
      subtitle: "Upgrade your office with Kadees",
      link: "/shop"
    },
    {
      img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?q=80&w=1470&auto=format&fit=crop",
      title: "Cozy Bedrooms",
      subtitle: "Comfort meets Style",
      link: "/shop"
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (prev, next) => {
      setDocActive(next);
    },
    appendDots: (dots) => (
      <div style={{ position: "absolute", top: "50%", left: "7%", transform: "translateY(-50%)" }}>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? { width: "30px", color: "#b45309", borderRight: "3px #b45309 solid", padding: "8px 0", cursor: "pointer", fontWeight: "bold" }
            : { width: "30px", color: "transparent", borderRight: "3px white solid", padding: "8px 0", cursor: "pointer" }
        }
      >
        0{i + 1}
      </div>
    ),
  };

  return (
    <div className="w-full bg-white relative">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <Link key={index} to={slide.link}>
            <div className="relative w-full h-[400px] md:h-[600px]">
              <img 
                src={slide.img} 
                alt={slide.title}
                className="w-full h-full object-cover" 
              />
              
              <div className="absolute top-0 left-0 w-full h-full bg-black/30 flex flex-col justify-center px-[10%]">
                 <motion.h1 
                   initial={{ opacity: 0, x: -20 }}
                   whileInView={{ opacity: 1, x: 0 }}
                   transition={{ duration: 0.5 }}
                   className="text-4xl md:text-6xl font-bold text-white mb-4"
                 >
                    {slide.title}
                 </motion.h1>
                 <motion.p 
                   initial={{ opacity: 0, x: -20 }}
                   whileInView={{ opacity: 1, x: 0 }}
                   transition={{ duration: 0.5, delay: 0.2 }}
                   className="text-lg md:text-2xl text-brandGold font-medium"
                 >
                    {slide.subtitle}
                 </motion.p>
                 <motion.button 
                   initial={{ opacity: 0, y: 20 }}
                   whileInView={{ opacity: 1, y: 0 }}
                   transition={{ duration: 0.5, delay: 0.4 }}
                   className="mt-8 bg-brandGold text-white w-40 h-12 rounded-sm hover:bg-white hover:text-primeColor duration-300 font-bold"
                 >
                    Shop Now
                 </motion.button>
              </div>
            </div>
          </Link>
        ))}
      </Slider>
    </div>
  );
};

export default Banner;